// src/lib/apiClient.js
import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_XANO_BACKEND_URL,
  timeout: 120_000,
});

// ↳ Intercepteur pour attacher le token JWT (si tu le gardes en mémoire)
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem("authToken");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
